<template>
  <div id="app">
    <router-view> </router-view>
  </div>
</template>

<script>
export default {
  name: "app",
  data() {
    return {
      loading: false,
    };
  },
  mounted() {
    var self = this;
    localStorage.setItem("loading", "false");
    setInterval(function () {
      if (localStorage.getItem("loading") == "false") {
        self.loading = false;
      }
    }, 200);
    self.$metaMask.init().then(() => {
      console.log(this.$route, "/////");
      
      // 初始化web3
      let web3 = self.$metaMask.getWeb3();
      // 遍历合约对象
      console.log(this.$store.state);

      self.$metaMask.getContract(web3, self.$abi);
  

      let parmas = {
        username: this.$store.state.wallet.account,
      };
      //是否注册
      this.$api.app.isRegister(parmas).then((res) => {
        this.$store.commit("SET_isRegister", res.data.isRegister);
        //注册登录
        let parmas1 = {
          username: this.$store.state.wallet.account,
          leader: this.$route.query.leader||'0x8156fcc50B2fdBb1deaD882aDdc6955223906666',
        };
        this.$api.app.register(parmas1).then((res) => {
          // this.$store.commit('SET_isRegister',res.data.isRegister)
          window.localStorage.setItem("Vtoken", res.data.userinfo.token);
              //首页信息
          this.$api.app.home().then((res) => {
            this.$store.commit("SET_homedata", res.data);
          
            this.$store.dispatch("balanceOf", { contract: "usdt", symbol: "usdt" });
            console.log('/////////////////////');
            
            let parmas={
					page:1,
				}
				this.$api.app.recommendList(parmas).then(res=>{

          this.$store.commit("SET_list", res.data);

				})
        this.$api.app.award().then(res => {
          this.$store.commit("SET_awardData", res.data);
				

			})
          });
        });
      });
   
    });
  },
  methods: {
    open_loading() {
      this.loading = true;
      localStorage.setItem("loading", "true");
    },
    close_loading() {
      this.loading = false;
    },
  },
};
</script>

<style>
.loading {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
}
.loading_img {
  position: absolute;
  left: calc(50% - 20px);
  top: calc(50% - 20px);
}
</style>
